var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('div',{staticStyle:{"color":"#d3d3d3","font-size":"40px","margin":"10px"}},[_vm._v("信息尚未完善")]),_c('notice',[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("通知相关人员")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }